export const FontSize = {
    mini: "10px",
    small: "12px",
    normal: "14px",
    medium: "16px",
    default: "16px",
    large: "20px",
    xl: "24px",
    xxl: "28px",
};

export const Font = {
    PrimaryFontFamily: "CircularStd",
    PrimaryFontSrc: "url('/resources/fonts/CircularStd-Book.eot')",
    PrimaryFontSrcRest:
        "local('CircularStd'), local('CircularStd')," +
        "url('/resources/fonts/CircularStd-Book.eot?#iefix') format('embedded-opentype')," /* IE6-IE8 */ +
        "url('/resources/fonts/CircularStd-Book.woff2') format('woff2')," /* Super Modern Browsers */ +
        "url('/resources/fonts/CircularStd-Book.woff') format('woff')," /* Modern Browsers */ +
        "url('/resources/fonts/CircularStd-Book.ttf') format('truetype')," /* Safari, Android, iOS */ +
        "url('/resources/fonts/CircularStd-Book.svg#bcc26993292869431e54c666aafa8fcd') format('svg')" /* legacy iOS */,
};
